/* tslint:disable */
/* eslint-disable */
/**
 * Commerce Webservices
 * Manages all of the common commerce functionality, and also includes customizations from installed AddOns. The implementing extension is called commercewebservices.
 *
 * The version of the OpenAPI document: 2.2.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DeprecatedPagination } from './DeprecatedPagination';
import {
    DeprecatedPaginationFromJSON,
    DeprecatedPaginationFromJSONTyped,
    DeprecatedPaginationToJSON,
} from './DeprecatedPagination';
import type { PointOfServiceStock } from './PointOfServiceStock';
import {
    PointOfServiceStockFromJSON,
    PointOfServiceStockFromJSONTyped,
    PointOfServiceStockToJSON,
} from './PointOfServiceStock';
import type { Product } from './Product';
import {
    ProductFromJSON,
    ProductFromJSONTyped,
    ProductToJSON,
} from './Product';
import type { Sort } from './Sort';
import {
    SortFromJSON,
    SortFromJSONTyped,
    SortToJSON,
} from './Sort';

/**
 * Representation of a Store Finder Stock Search Page
 * @export
 * @interface StoreFinderStockSearchPage
 */
export interface StoreFinderStockSearchPage {
    /**
     * List of stores
     * @type {Array<PointOfServiceStock>}
     * @memberof StoreFinderStockSearchPage
     */
    stores?: Array<PointOfServiceStock>;
    /**
     * List of sorts
     * @type {Array<Sort>}
     * @memberof StoreFinderStockSearchPage
     */
    sorts?: Array<Sort>;
    /**
     * 
     * @type {DeprecatedPagination}
     * @memberof StoreFinderStockSearchPage
     */
    pagination?: DeprecatedPagination;
    /**
     * Location text
     * @type {string}
     * @memberof StoreFinderStockSearchPage
     */
    locationText?: string;
    /**
     * Source latitude
     * @type {number}
     * @memberof StoreFinderStockSearchPage
     */
    sourceLatitude?: number;
    /**
     * Source longitude
     * @type {number}
     * @memberof StoreFinderStockSearchPage
     */
    sourceLongitude?: number;
    /**
     * Bound to north latitude
     * @type {number}
     * @memberof StoreFinderStockSearchPage
     */
    boundNorthLatitude?: number;
    /**
     * Bound to east longitude
     * @type {number}
     * @memberof StoreFinderStockSearchPage
     */
    boundEastLongitude?: number;
    /**
     * Bound to south latitude
     * @type {number}
     * @memberof StoreFinderStockSearchPage
     */
    boundSouthLatitude?: number;
    /**
     * Bound to west longitude
     * @type {number}
     * @memberof StoreFinderStockSearchPage
     */
    boundWestLongitude?: number;
    /**
     * 
     * @type {Product}
     * @memberof StoreFinderStockSearchPage
     */
    product?: Product;
}

/**
 * Check if a given object implements the StoreFinderStockSearchPage interface.
 */
export function instanceOfStoreFinderStockSearchPage(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function StoreFinderStockSearchPageFromJSON(json: any): StoreFinderStockSearchPage {
    return StoreFinderStockSearchPageFromJSONTyped(json, false);
}

export function StoreFinderStockSearchPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): StoreFinderStockSearchPage {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'stores': !exists(json, 'stores') ? undefined : ((json['stores'] as Array<any>).map(PointOfServiceStockFromJSON)),
        'sorts': !exists(json, 'sorts') ? undefined : ((json['sorts'] as Array<any>).map(SortFromJSON)),
        'pagination': !exists(json, 'pagination') ? undefined : DeprecatedPaginationFromJSON(json['pagination']),
        'locationText': !exists(json, 'locationText') ? undefined : json['locationText'],
        'sourceLatitude': !exists(json, 'sourceLatitude') ? undefined : json['sourceLatitude'],
        'sourceLongitude': !exists(json, 'sourceLongitude') ? undefined : json['sourceLongitude'],
        'boundNorthLatitude': !exists(json, 'boundNorthLatitude') ? undefined : json['boundNorthLatitude'],
        'boundEastLongitude': !exists(json, 'boundEastLongitude') ? undefined : json['boundEastLongitude'],
        'boundSouthLatitude': !exists(json, 'boundSouthLatitude') ? undefined : json['boundSouthLatitude'],
        'boundWestLongitude': !exists(json, 'boundWestLongitude') ? undefined : json['boundWestLongitude'],
        'product': !exists(json, 'product') ? undefined : ProductFromJSON(json['product']),
    };
}

export function StoreFinderStockSearchPageToJSON(value?: StoreFinderStockSearchPage | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'stores': value.stores === undefined ? undefined : ((value.stores as Array<any>).map(PointOfServiceStockToJSON)),
        'sorts': value.sorts === undefined ? undefined : ((value.sorts as Array<any>).map(SortToJSON)),
        'pagination': DeprecatedPaginationToJSON(value.pagination),
        'locationText': value.locationText,
        'sourceLatitude': value.sourceLatitude,
        'sourceLongitude': value.sourceLongitude,
        'boundNorthLatitude': value.boundNorthLatitude,
        'boundEastLongitude': value.boundEastLongitude,
        'boundSouthLatitude': value.boundSouthLatitude,
        'boundWestLongitude': value.boundWestLongitude,
        'product': ProductToJSON(value.product),
    };
}

